import {
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';

const ImagePreviewHeight = '96px';

export const useStyles = makeStyles({
  displayRecommendedImage: {
    '& .image-suggestion-carousel-loading': {
      '& .parent-item': {
        display: 'flex',
        ...shorthands.gap('8px'),
      },
      '& .item': {
        height: '66px',
        width: '72px',
      },
    },
    '& .helpbutton': {
      display: 'inline',
    },

  },
  imagePreviewContainer: {
    height: ImagePreviewHeight,
    position: 'relative',
    ...shorthands.margin('12px', 0),
    '& .image-preview': {
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
    },
    backgroundImage: 'linear-gradient(45deg, #EBEBEB 25%, transparent 25%), linear-gradient(-45deg, #EBEBEB 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #EBEBEB 75%), linear-gradient(-45deg, transparent 75%, #EBEBEB 75%)',
    backgroundSize: '40px 40px',
    backgroundPositionX: '0px, 0px, 20px, -20px',
    backgroundPositionY: '0px, 20px, -20px, 0px',
    backgroundColor: '#FAFAFA',
  },
  checkerImage: {
    position: 'absolute',
    width: '100%',
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    ...shorthands.border('0.5px', 'solid', '#E1E1E1'),
    display: 'flex',
    justifyContent: 'center',
  },
  overlay: {
    position: 'absolute',
    height: '96px',
    left: 0,
    right: 0,
    backgroundColor: tokens.colorBackgroundOverlay,
  },
  multipleBtn: {
    width: '100%',
    display: 'flex',
    color: tokens.colorNeutralForeground4,
    fontSize: tokens.fontSizeBase200,
    flexDirection: 'column',
    ...shorthands.border('0.5px', 'solid', '#E1E1E1'),
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  previewImage: {
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '100%',
      maxHeight: '100%',
    },
  },
  actionBtns: {
    display: 'flex',
    position: 'absolute',
    ...shorthands.gap('8px'),
    bottom: '10px',
    left: '50%',
    transform: 'translate(-50%, 0)',
    '& button': {
      ...shorthands.borderRadius(tokens.borderRadiusSmall),
      backgroundColor: tokens.colorNeutralBackground1,
      ...shorthands.border(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke1),
    },
  },
  helpButton: {
    marginLeft: tokens.spacingHorizontalSNudge,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});

export const initialImageContainerLeftMargin = 0;

const IMAGE_DIM = {
  width: 68,
  height: 62,
  marginRight: 8,
};
const PaddleBottomValue = 18;
export const getFullyShownImagesCount = (width) => {
  if (!width) {
    return 0;
  }

  const itemWidth = IMAGE_DIM.width + IMAGE_DIM.marginRight;

  return Math.floor(width / itemWidth);
};
export const getCarouselStyles = (_components, _palette, iconFontFamily = 'MsAds MDL2 Assets') => ({
  carouselParent: {
    position: 'relative',
    display: 'inline-flex',
    width: '100%',
    alignItems: 'end',
  },
  disabledCarouselParent: {
    pointerEvents: 'none',
    opacity: 0.4,
  },
  image: {
    ...IMAGE_DIM,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    objectFit: 'cover',
    borderRadius: 6,
  },
  imageContainer: ({ imageContainerLeftMargin, isCollapsible }) => ({
    height: IMAGE_DIM.height,
    overflowX: 'hidden',
    overflowY: 'hidden',
    display: 'inline-block',
    marginLeft: isCollapsible ? imageContainerLeftMargin : 0,
    flexGrow: 1,
  }),
  imageParentContainer: ({ imageParentLeftOffset, numberOfImages }) => ({
    display: 'flex',
    width: (IMAGE_DIM.width + IMAGE_DIM.marginRight) * numberOfImages,
    position: 'relative',
    left: ((-1 * IMAGE_DIM.width) - IMAGE_DIM.marginRight) * imageParentLeftOffset,
  }),
  imageClickableContainer: {
    display: 'inline',
    '& :hover': {
      cursor: 'pointer',
    },
  },
  panel: {},
  panelHeading: {
    display: 'flex',
    marginBottom: '12px',
    '& .recommendation-icon': {
      width: '14px',
      height: '14px',
      margin: '0 8px',
    },
  },
  panelTitle: {
    flexGrow: 1,
  },
  panelIcon: {
    marginRight: 3,
    paddingBottom: 12,
    '&:before': {
      fontFamily: iconFontFamily,
      content: '"\\E3AF"',
    },
  },
  panelHelpButton: {
    display: 'none',
  },
  imageHintRight: {
    display: 'inline-block',
    position: 'absolute',
    background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
    width: 20,
    height: IMAGE_DIM.height,
    right: 20,
  },
  imageHintLeft: {
    display: 'inline-block',
    position: 'absolute',
    background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
    width: 30,
    height: IMAGE_DIM.height,
    left: 20,
    transform: 'rotate(-180deg)',
  },
  paddleBtn: {
    bottom: PaddleBottomValue,

  },
  moreIcon: {
    fontSize: '18px',
    height: '60px',
    width: '33px',
  },
  seeAll: {
    display: 'inline-block',
    position: 'absolute',
    right: 0,
    bottom: 12,
    whiteSpace: 'nowrap',
    maxWidth: 50,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: `${tokens.colorNeutralForeground2BrandSelected} !important`,
  },
  seeAllInHeader: {
    float: 'right',
    '& a': {
      position: 'static',
      fontSize: 12,
      paddingRight: 0,
      '&:hover, $:acitve, $:focus': {
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  parentContainer: {
    '& .paddle-right, & .paddle-left': {
      width: '20px',
      height: '20px',
      '& i': {
        color: tokens.colorNeutralForeground3,
        fontSize: '12px',
      },
    },
    '& $panel': { // need more selector specificity to override styles applied to top of grid panels
      marginLeft: 0,
      marginTop: 12,
      marginBottom: 0,
    },
    '& $panelHeading': {
      border: 'none',
      '& $panelTitle.collapsible-title': {
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '24px',
        '& > a:hover': {
          backgroundColor: 'transparent',
        },
        marginTop: 0,
      },
    },
    '& + .alert-info': {
      marginTop: 8,
      '& a': {
      },
    },
  },
});
